import {connect} from 'react-redux';

import {changeResolution} from 'topmeteo/general/actionCreators';

export const getLabel = resolution => `${resolution}min`;

export const Resolutions = [5, 15, 60].map(value => ({key: value, label: getLabel(value), value}));

const ResolutionItem = ({label, onClick}) => (
    <li onClick={onClick}>{label}</li>
);

const mapDispatchToProps = (dispatch, {value}) => ({
    onClick: () => dispatch(changeResolution(value)),
});

export default connect(undefined, mapDispatchToProps)(ResolutionItem);
